import { CoralogixRum } from '@coralogix/browser';


const getRegion = () => {
  const host = window.location.host;
  if (host.includes("us11"))            return "us-east-1";
  if (host.includes("ca12"))            return "ca-central-1";
  if (host.includes("ir31"))            return "eu-west-1";
  if (host.includes("in22"))            return "ap-south-2";
  if (host.endsWith("crm4b2c.com"))     return "ap-southeast-1";
  if (host.endsWith("lsq-staging.com")) return "ap-south-1";
  if (host.endsWith("leadsquared.com")) return "ap-south-1";
  return "local";
};

/**
 * Monitoring abstraction layer.
 * Currently backed by Coralogix RUM.
 * To switch providers, update only this file — all callers stay unchanged.
 */

/**
 * Identify the current user/tenant for session attribution.
 * Populates cx_rum.session_context.user_metadata with org_code and cloud_region.
 * app_instance_name is set automatically from application_name in the init config.
 */
export const setUserContext = ({ userId, orgCode } = {}) => {
  try {
    CoralogixRum.setUserContext({
      user_id: userId ? String(userId) : undefined,
      user_metadata: {
        ...(orgCode && { org_code: String(orgCode) }),
        cloud_region: getRegion(),
      },
    });
  } catch (_) { /* ignore RUM errors */ }
};

/** Attach a persistent label/attribute to all subsequent RUM events. */
export const setAttribute = (key, value) => {
  try {
    CoralogixRum.setLabels({ [key]: String(value) });
  } catch (_) { /* ignore RUM errors */ }
};

/** Report a caught error. */
export const recordError = (error, context) => {
  try {
    CoralogixRum.reportError(error, context);
  } catch (_) { /* ignore RUM errors */ }
};

/** Track a custom event / action (e.g. API call metadata). */
export const trackEvent = (name, data) => {
  try {
    CoralogixRum.log(3, name, { ...data });
  } catch (_) { /* ignore RUM errors */ }
};

/** Add a debug-level trace annotation. */
export const addTrace = (name, data) => {
  try {
    CoralogixRum.log(1, name, { ...data });
  } catch (_) { /* ignore RUM errors */ }
};
